import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { gcpSortedAccountsSelector } from "./gcpSortedAccountsSelector";
import { nonDeletedAccountsCombiner } from "../../combiners/nonDeletedAccountsCombiner";

export const gcpNonDeletedAccountsSelector = createDraftSafeSelector(
  [gcpSortedAccountsSelector],
  nonDeletedAccountsCombiner,
);
